import React from "react"
import { Flex, Tag } from "antd"
import PropTypes from "prop-types"
import { CircledClose } from "ui/Icon/DSIcon/CircledClose"
import styles from "./index.module.css"

const CategoryChips = ({ selectedCategories, categoryOptions, setSelectedCategories }) => {
  const shownCategories = selectedCategories.filter((c) => c !== "all")

  if (!shownCategories.length) return null

  const handleRemoveCategory = (cat) => {
    setSelectedCategories(selectedCategories.filter((c) => c !== cat && c !== "all"))
  }

  return (
    <Flex gap={4} className="mt-s">
      {shownCategories.map((cat) => {
        const option = categoryOptions.find((o) => o.value === cat)
        if (!option) return null

        return (
          <Tag
            key={cat}
            className={styles.categoryChip}
            bordered={true}
            closable
            closeIcon={<CircledClose width={16} height={16} fill="var(--color-sportsman-brand, #1d72f4)" />}
            onClose={(e) => {
              e.preventDefault()
              handleRemoveCategory(cat)
            }}
          >
            {option.label}
          </Tag>
        )
      })}
    </Flex>
  )
}

CategoryChips.propTypes = {
  selectedCategories: PropTypes.array.isRequired,
  categoryOptions: PropTypes.array.isRequired,
  setSelectedCategories: PropTypes.func.isRequired
}

export default React.memo(CategoryChips)
